import styled from "@digits-css"
import colors from "@digits-shared/themes/colors"
import "./typography.digits.css"

const H1_TEXT_STYLES = `
  font-size: 24px;
  line-height: 33px;
  font-weight: 900;
`

const H2_TEXT_STYLES = `
  font-size: 18px;
  line-height: 25px;
  font-weight: 800;
`

const BODY_TEXT_STYLES = `
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;
`

const DETAIL_TEXT_STYLES = `
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
`

const LABEL_TEXT_STYLES = `
  font-size: 10px;
  line-height: 14px;
  font-weight: 400;
`

const fonts = {
  family: {
    avenir: "'Avenir', Helvetica, Arial, sans-serif",
    amithen: "Amithen, Helvetica, Arial, sans-serif",
    monospace: {
      courierNew: "'Courier Prime', 'Courier New', Courier, monospace",
    },
  },
  weight: {
    light: 300,
    book: 350,
    normal: 400,
    roman: 400,
    medium: 500,
    heavy: 800,
    black: 900,
  },
  style: {
    normal: "normal",
    oblique: "oblique",
  },
  scale: {
    h1: H1_TEXT_STYLES,
    h2: H2_TEXT_STYLES,
    body: BODY_TEXT_STYLES,
    detail: DETAIL_TEXT_STYLES,
    label: LABEL_TEXT_STYLES,
  },
}
export default fonts

interface TextProps {
  color?: string
  weight?: "light" | "book" | "normal" | "roman" | "medium" | "heavy" | "black"
}

export const H1Text = styled.div({ cls: "typography__H1Text_c4326f6", vars: { "--typography__H1Text_c4326f6-p0": ({ weight }) => (weight ? fonts.weight[weight] : fonts.weight.black), "--typography__H1Text_c4326f6-p1": ({ color }) => (color ? color : colors.secondary) } })

export const H2Text = styled.div({ cls: "typography__H2Text_4dfe010", vars: { "--typography__H2Text_4dfe010-p0": ({ weight }) => (weight ? fonts.weight[weight] : fonts.weight.heavy), "--typography__H2Text_4dfe010-p1": ({ color }) => (color ? color : colors.secondary) } })

export const BodyText = styled.div({ cls: "typography__BodyText_ee866a4", vars: { "--typography__BodyText_ee866a4-p0": ({ weight }) => (weight ? fonts.weight[weight] : fonts.weight.roman), "--typography__BodyText_ee866a4-p1": ({ color }) => (color ? color : colors.secondary) } })

export const DetailText = styled.div({ cls: "typography__DetailText_28b4596", vars: { "--typography__DetailText_28b4596-p0": ({ weight }) => (weight ? fonts.weight[weight] : fonts.weight.roman), "--typography__DetailText_28b4596-p1": ({ color }) => (color ? color : colors.secondary) } })

export const LabelText = styled.span({ cls: "typography__LabelText_8f854c6", vars: { "--typography__LabelText_8f854c6-p0": ({ weight }) => (weight ? fonts.weight[weight] : fonts.weight.roman), "--typography__LabelText_8f854c6-p1": ({ color }) => (color ? color : colors.secondary) } })
